module.exports = __webpack_public_path__ + "img/icn_reserve.2e547ea9.svg";